import { mode, userPermission } from '@/helpers/enum';
import { isObjectEmpty } from '@/helpers/utils';
import router from '@/routes';
import { parseFormFieldsProperties } from '../helpers/utils';
import api from '../services/api';
import { initialData } from './state';
export default {
  hasPermission({ state }, permissionId) {
    if (!Object.values(userPermission)
      .some(permission => permission === permissionId)) throw new Error('PermissionId should be used throw enum');
    if (!permissionId) return false;
    return ((state.userInfo || {}).userPermissions || []).some(permission => permission == permissionId);
  },
  updateSettings({ commit }, payload) {
    commit('updateSettings', payload);
  },
  executeHttpRequest(_context, payload) {
    return api.executeHttpRequest(payload);
  },
  getUserInfo({ commit }) {
    api.getUserInfo()
      .then((res) => {
        commit('updateUserInfo', res.data);
      });
  },
  getSideNavItems({ commit, state }) {
    if ((state.sideNav.data || []).length)
      return state.sideNav.data;
    else
      return api.getSideNavItems()
        .then((res) => {
          commit('updateSideNavItems', res.data);
          return res.data;
        });
  },
  getNotificationsCount({ commit }) {
    return api.getNotificationsCount()
      .then((res) => {
        commit('updateNotificationsCount', res.data);
        return res.data;
      });
  },
  getNotificationList(_context, searchQuery) {
    return api.getNotificationList(searchQuery)
      .then((res) => {
        return res.data;
      });
  },
  patchNotificationSeen({ commit }, unseenList) {
    if ((unseenList || []).length)
      return api.patchNotificationSeen(unseenList)
        .then(() => {
          api.getNotificationsCount()
            .then((res) => {
              commit('updateNotificationsCount', res.data);
              return res.data;
            });
        });
    else
      return Promise.resolve([]);
  },
  putNotificationSeen({ commit }, id) {
    return api.putNotificationSeen(id)
      .then(() => {
        commit('decrementNotificationsCount');
      });
  },
  incrementNotificationsCount({ commit }) {
    commit('incrementNotificationsCount');
  },
  setActiveNavItem({ commit }, payload) {
    if (payload) {
      commit('updateActiveNavItem', {
        ...payload,
        properties: JSON.parse(payload.properties) || {},
      });
    } else {
      commit('resetActiveNavItem');
    }
  },
  toggleSideNavVisibility({ commit, state }, payload) {
    if (payload === 'reset') payload = localStorage.getItem('side-nav-collapsed') == 'true';
    commit('setSideNavVisibility', payload || !state.sideNav.collapsed);
  },
  toggleAndPersistSideNavVisibility({ state, dispatch }, payload) {
    dispatch('toggleSideNavVisibility', payload);
    localStorage.setItem('side-nav-collapsed', state.sideNav.collapsed);
  },
  async getDataGrid({ commit, state, getters }, payload) {
    commit('updateDataGrid', initialData().dataGrid);
    const gridId = payload || getters.activeMenuItemGridId;
    if (gridId) {
      const dataGrid = state.flatDataGrids[gridId];
      if (dataGrid) {
        return Promise.resolve(dataGrid)
          .then((res) => {
            commit('updateDataGridLabel', res.label);
            commit('updateDataGridEndPointUrl', res.configurations.endPointUrl);
            commit('updateDataGridFilters', res.configurations.filters);
            commit('updateDataGridActions', res.configurations.actions);
            commit('updateDataGridProperties', res.configurations.properties);
            commit('updateDataGridColumns', res.configurations.headers || res.configurations.columns);
          });
      } else {
        return api.getDynamicGrid(gridId)
          .then((res) => {
            commit('addDataGrid', res.data);
            commit('updateDataGridLabel', res.data.label);
            commit('updateDataGridEndPointUrl', res.data.configurations.endPointUrl);
            commit('updateDataGridFilters', res.data.configurations.filters);
            commit('updateDataGridActions', res.data.configurations.actions);
            commit('updateDataGridProperties', res.data.configurations.properties);
            commit('updateDataGridColumns', res.data.configurations.headers || res.data.configurations.columns);
          });
      }
    }
    return Promise.resolve();
  },
  getDataGridItems({ commit, state }) {
    let endPointUrl = state.dataGrid.endPointUrl;
    if (endPointUrl) {
      const query = {
        ...state.dataGrid.searchQuery.fields,
        ...state.dataGrid.searchQuery.filters,
        ...state.dataGrid.searchQuery.paging,
        ...state.dataGrid.searchQuery.sorting,
        serializer: 'repeat',
      };
      endPointUrl = endPointUrl.replace(/\{(.*?)\}/g, (_match, token) => query[token]);
      return api
        .getDataGridItems(endPointUrl, query)
        .then((res) => {
          commit('updateDataGridItems', {
            items: res.data.list,
            total: res.data.totalCount,
            pageIndex: res.data.pageIndex,
            pageSize: res.data.pageSize,
          });
          return res;
        })
        .catch((error) => {
          return error;
        });
    }
    return Promise.resolve();
  },
  getDataGridItemsForExcel(_context, config) {
    if (config.endPointUrl) {
      const query = {
        ...config.searchQuery,
        pageIndex: 0,
        pageSize: 99999999,
        serializer: 'repeat',
      };
      config.endPointUrl = config.endPointUrl.replace(/\{(.*?)\}/g, (_match, token) => query[token]);
      return api
        .getDataGridItemsForExcel(config.endPointUrl, query);
    }
    return Promise.resolve();
  },
  sortChange({ commit }, payload) {
    commit('updateDataGridSorting', payload);
  },
  pageChange({ commit }, payload) {
    commit('updateDataGridPageIndex', payload);
  },
  pageSizeChange({ commit }, payload) {
    commit('updateDataGridPageSize', payload);
  },
  searchChange({ commit }, payload) {
    delete payload.shown;
    for (const key in payload)
      if (Object.hasOwnProperty.call(payload, key) && (payload[key] === undefined || payload[key] === null || (Array.isArray(payload[key]) && !payload[key].length)) && payload[key] !== false)
        delete payload[key];
    commit('updateDataGridSearchQuery', payload);
    router.replace({ query: { q: Object.keys((payload || {})).length ? JSON.stringify(payload) : undefined } })
      .catch(() => { });
  },
  printSearchChange({ commit }, payload) {
    commit('updateDataGridSearchQuery', payload);
  },
  updateAppLoader({ commit }, payload) {
    commit('updateAppLoader', payload);
  },
  updateOverlayLoader({ commit }, payload) {
    commit('updateOverlayLoader', payload);
  },
  updateBreadcrumbs({ commit }, payload) {
    commit('updateBreadcrumbs', payload);
  },
  clearBreadcrumbsData({ commit }) {
    commit('clearBreadcrumbsData');
  },
  getDashboardChartData(context, payload) {
    return api.getDashboardChartData(payload)
      .then(res => res.data);
  },
  getDashboards() {
    return api.getDashboards()
      .then(res => res.data);
  },
  getDynamicForms({ state, commit }) {
    if ((state.dynamicForms || []).length)
      return state.dynamicForms;
    else
      return api.getDynamicForms()
        .then((forms) => {
          commit('updateDynamicForms', forms);
          return forms;
        });
  },
  getDynamicForm({ state, commit }, { formId, withoutParse = false }) {
    return api.getDynamicForm(formId)
      .then((form) => {
        commit(
          'updateDynamicForms',
          state.dynamicForms.map(f => (f.id == formId ? form.data : f))
        );
        return {
          ...form.data,
          fields: withoutParse ? form.data.fields : parseFormFieldsProperties(form.data.fields),
        };
      });
  },
  getDynamicFormFields({ state, dispatch, commit }, formId) {
    let selectedForm = state.dynamicForms.find(form => form.id == formId);
    let getAllDynamicForms = Promise.resolve([selectedForm]);
    if (!selectedForm) {
      getAllDynamicForms = dispatch('getDynamicForms');
    }
    return getAllDynamicForms.then((forms) => {
      const form = forms.find(form => form.id == formId);

      return api.getDynamicFormFields(formId)
        .then((fields) => {
          selectedForm = {
            ...form,
            fields: parseFormFieldsProperties(fields.data),
          };
          commit('updateDynamicForm', selectedForm);

          return selectedForm;
        });
    });
  },
  getDynamicFormFlatFields(_context, payload) {
    return api.getDynamicFormFlatFields(payload)
      .then(res => (res.data || []).map(f => ({
        ...f,
        dataSource: (JSON.parse(f.properties) || {}).dataSource,
      })));
  },
  editDynamicForm({ state, commit }, dynamicForm) {
    removeFieldsExtraProperties(dynamicForm.fields);
    return api.editDynamicForm(dynamicForm, dynamicForm.id)
      .then(() => {
        commit(
          'updateDynamicForms',
          state.dynamicForms.map(form => (form.id == dynamicForm.id ? dynamicForm : form))
        );
      });
  },
  getDynamicGrids({ commit }) {
    return api.getDynamicGrids()
      .then((grids) => {
        commit('updateDynamicGrids', grids);
      });
  },
  getDynamicGridsHasForms({ state, commit }) {
    if ((state.dynamicGrids || []).length)
      return state.dynamicGrids;
    else
      return api.getDynamicGridsHasForms()
        .then((grids) => {
          commit('updateDynamicGrids', grids);
        });
  },
};

const removeFieldsExtraProperties = (fields) => {
  if (Array.isArray(fields))
    fields.forEach((f) => {
      if (typeof f.properties === 'string')
        f.properties = JSON.parse(f.properties);
      delete f.properties['dataSource'];
      delete f.properties['dataGridConfig'];
      if (isObjectEmpty(f.properties['dateConfig']))
        delete f.properties['dateConfig'];
      if (isObjectEmpty(f.properties['validations']))
        delete f.properties['validations'];
      f.properties = JSON.stringify(f.properties);
      removeFieldsExtraProperties(f.fields);
    });
};
